import { GetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentScheduleResponse } from '@iwoca/lapi-client/introducer_portal';
import { Table } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { useLocale } from 'hooks/useLocale';
import { useNumberFormat } from 'hooks/useNumberFormat';

import styles from './RCFRepaymentSchedule.module.css';

type TSchedule =
  GetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentScheduleResponse['data']['schedule'];

type TProps = {
  schedule: TSchedule;
};

export const InterestOnlyTable = ({ schedule }: TProps) => {
  const { i18n } = useLocale();
  const { formatCurrency } = useNumberFormat();

  return (
    <Table
      id="interest-only-table"
      className={styles.table}
      maxHeight={512}
      columns={[
        {
          accessorFn: (repayment: TSchedule[number]) => {
            return i18n.date(repayment.date, {
              day: '2-digit',
              month: 'numeric',
              year: 'numeric',
            });
          },
          header: t`Date`.toUpperCase(),
        },
        {
          accessorFn: (repayment: TSchedule[number]) => {
            return formatCurrency(repayment.principal, { fractionDigits: 2 });
          },
          header: t`Original loan`.toUpperCase(),
        },
        {
          accessorFn: (repayment: TSchedule[number]) => {
            return formatCurrency(repayment.interest, { fractionDigits: 2 });
          },
          header: t`Fees + interest`.toUpperCase(),
        },
        {
          id: 'total',
          accessorFn: (repayment: TSchedule[number]) => repayment.total,
          header: t`Total`.toUpperCase(),
          cell: ({ row }) => {
            const repayment = row.original as TSchedule[number];
            return (
              <div>
                {formatCurrency(repayment.total, { fractionDigits: 2 })}
                {row.index === 0 && repayment.total_fees > 0 && (
                  <span className={styles.feeNote}>
                    {t`incl. ${formatCurrency(repayment.total_fees, { fractionDigits: 2 })} fee`}
                  </span>
                )}
              </div>
            );
          },
        },
      ]}
      data={schedule}
      pinFirstCol={false}
    />
  );
};
